import { render, staticRenderFns } from "./CollaborationAppointment.vue?vue&type=template&id=5ae7fda3&scoped=true"
import script from "./CollaborationAppointment.vue?vue&type=script&lang=js"
export * from "./CollaborationAppointment.vue?vue&type=script&lang=js"
import style0 from "./CollaborationAppointment.vue?vue&type=style&index=0&id=5ae7fda3&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_qfdn4gbztslujeagaknuyibsmy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ae7fda3",
  null
  
)

export default component.exports